import React from "react";
import { Box, FormHelperText } from "@mui/material";
import { convertDateDashDMY } from "../../utils/jsUtils";

function DeliveryDateComponent({
  deliveryDateArray,
  index,
  deliveryDateArray1,
}) {
  const content = deliveryDateArray[index]
    ? String(deliveryDateArray[index])
    : "";

  const content1 = deliveryDateArray1?.[index]
    ? String(deliveryDateArray1?.[index])
    : "";

  return (
    <Box>
      <Box display="flex" justifyContent="left">
        <FormHelperText style={{ color: "black", fontSize: "10px" }}>
          {content1 === "" ? "" : " Min Delivery Date : "}
          {content1 === "" ? "" : convertDateDashDMY(content1)}
        </FormHelperText>
      </Box>
      <Box display="flex" justifyContent="left">
        <FormHelperText style={{ color: "black", fontSize: "10px" }}>
          {content === "" ? "" : " Max Delivery Date : "}
          {content === "" ? "" : convertDateDashDMY(content)}
        </FormHelperText>
      </Box>
    </Box>
  );
}

export default DeliveryDateComponent;
